
import { Location } from '@angular/common';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ModalService, ToastService, ControlsComponent } from '../../blocks';
import { AppCodeGroup, ControlsParams, SharedDateService, UserSessionService, CashierParms } from '../../shared';

import { takeUntil } from 'rxjs/operators'; import { Subject } from 'rxjs';
import { DocManagementTrans } from '../../document-management/interface/doc-manag-model';
import { SnDocumentType } from '../../document-management/document-type';
@Component({
    selector: 'sanabel-chequeDetail',
    templateUrl: './cheque-detail.component.html'
})
export class ChequeDetailComponent implements OnInit, OnDestroy {
    editChequeDetail: CshCashierTransCheque = <CshCashierTransCheque>{};
    chequeDetail: CshCashierTransCheque = <CshCashierTransCheque>{};
    chequeValue: number;
    chequeTransSerial: number;
    chequeState: number = null;
    controlsParams: ControlsParams;
    chequeDetailForm: UntypedFormGroup;
    day: any;
    private ngUnsubscribe: Subject<void> = new Subject<void>();
    @Input() popupClose: any;
    @Input() chequeType: number;
    constructor(
        public translate: TranslateService,
        private _modalService: ModalService,
        private _location: Location,
        private _toastService: ToastService,
        private _userSessionService: UserSessionService,
        private _sharedDateService: SharedDateService) {
        this.controlsParams = new ControlsParams(77, AppCodeGroup.Buttons, true);
    }

    documentLookupCode: number

    ngOnInit() {
        this.initChequeDetail();
        if (this._userSessionService.getSessionKey<CashierParms>('chequeParms')) {
            this.chequeDetail = this._userSessionService.getSessionKey<CshCashierTransCheque>('chequeParms');
            this.setChequedata();
        }
        if (this._userSessionService.getModalKey('ChequeDetailComponent')) {
            this.chequeDetail = <any>{};
            this.chequeDetail = this._userSessionService.getModalKey('ChequeDetailComponent')["inputs"];
            this.setChequedata();
        }
        this._userSessionService.getModalKey$().pipe(
            takeUntil(this.ngUnsubscribe))
            .subscribe((keys: any) => {
                this.chequeDetail = <any>{};
                if (keys.name == 'ChequeDetailComponent' && keys.inputs) {
                    this.chequeDetail = keys.inputs;
                    this.setChequedata();

                }
            });
    }
    setChequedata() {
        this.chequeDetailForm.reset();
        this.chequeDetailForm.get('value').setValue(+this.chequeDetail.value ? +this.chequeDetail.value : +this.chequeDetail.chequeValue)
        let day = this._sharedDateService.day$.subscribe(day => {
            this.chequeDetailForm.get('transDate').setValue(this._sharedDateService.convertFromDateToNgBsObject(day));
            this.chequeDetailForm.get('dueDate').setValue(this._sharedDateService.convertFromDateToNgBsObject(this.chequeDetail.dueDate));

        }, null, () => { day.unsubscribe() })
        this.chequeType = this.chequeDetail.chequeType;
        this.chequeState = this.chequeDetail.chequeState;
        this.chequeTransSerial = this.chequeDetail.serial
        this.documentLookupCode = this.chequeDetail.documentLookupCode;
        if (Object.keys(this.chequeDetail).length !== 0) {
            this.chequeDetailForm.patchValue(this.chequeDetail)
        }
    }
    initChequeDetail() {
        this.chequeDetailForm = new UntypedFormGroup({
            serial: new UntypedFormControl(),
            value: new UntypedFormControl('', Validators.required),
            number: new UntypedFormControl('', Validators.required),
            cshCashierTransSerial: new UntypedFormControl(),
            cshBankStpCode: new UntypedFormControl('', Validators.required),
            transDate: new UntypedFormControl('', Validators.required),
            dueDate: new UntypedFormControl('', Validators.required),
            cshVisaCardsTypeCode: new UntypedFormControl()
        })
        let day = this._sharedDateService.day$.subscribe(day => {
            this.chequeDetailForm.get('transDate').setValue(this._sharedDateService.convertFromDateToNgBsObject(day));
            this.chequeDetailForm.get('dueDate').setValue(this._sharedDateService.convertFromDateToNgBsObject(this.chequeDetail.dueDate));

        }, null, () => { day.unsubscribe() })
    }


    save() {

        this.editChequeDetail = this.chequeDetailForm.value;
        if (!(this.editChequeDetail.serial > 0)) {
            this.editChequeDetail.serial = 0;
        }
        if (Object.keys(this.chequeDetail).length !== 0) {
            this.editChequeDetail.value = this.chequeDetail.value ? this.chequeDetail.value : this.chequeDetail.chequeValue;
        } else if (this.chequeValue) {
            this.editChequeDetail.value = this.chequeValue;
        }
        this.editChequeDetail.chequeType = this.chequeType; // (1)شيك صادر  (2)  ,شيك وارد
        this.editChequeDetail.chequeState = this.chequeState == null ? 1 : this.chequeState; //  1: شيك تحت التحصيل
        this.editChequeDetail.transDate = this._sharedDateService.convertFromNgBsToDate(this.editChequeDetail.transDate);
        this.editChequeDetail.dueDate = this._sharedDateService.convertFromNgBsToDate(this.editChequeDetail.dueDate);
        if (this.editChequeDetail.dueDate < this.editChequeDetail.transDate) {
            this._toastService.activateMsg('UI13');
            return;
        }
        this._userSessionService.setSessionKey('chequeDetail', this.editChequeDetail);
        if (this.popupClose) {
            this.chequeDetailForm.reset();
            this.popupClose('Close click');
            return;
        }
        this._userSessionService.closeModalKey('ChequeDetailComponent', this.editChequeDetail);

    }


    _goBack(): void {
        this._location.back();
    }
    docManagementData: DocManagementTrans = {
        documentLookupCode: SnDocumentType.PersonnalImages,
        dataStatus: undefined
    };
    onOutBase64(event) {
        this.docManagementData.base64 = event;
        if (this.docManagementData.dataStatus == undefined) {
            this.docManagementData.dataStatus = 1;
        }
    }
    saveimageObj(ev: DocManagementTrans) {
        console.log(ev);
        ev.dataStatus = 1
        // this._approvalsService.addDocManagementTrans(ev).pipe(
        //     takeUntil(this.ngUnsubscribe))
        //     .subscribe((result) => {
        //         if (result["returnFlag"]) {
        //             console.log(result)
        //         }
        //     });
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }


}


export interface CshCashierTransCheque {
    serial: number
    value?: number;
    number?: number;
    cshCashierTransSerial?: number;
    cshBankStpserial: number;
    transDate?: Date;
    dueDate?: Date;
    cash_obtDate?: Date;
    chequeType?: number;
    chequeState?: number;
    importedBank?: number;
    depositReceiptSerial?: number;
    cshBankStpCode?: number,
    benfType?: number,
    openingBalanceFlag?: number;
    benfCode?: number;
    documentLookupCode?: number
    cshVisaCardsTypeCode?: number;
    cshCurrencyFactor?: number;
    chequeValue?: number;
    UpdateStatus?: number;

}
